import script from "./PageHeaderFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeaderFilters.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeaderFilters.vue?vue&type=style&index=0&id=dd5c8ab2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd5c8ab2"]])

export default __exports__